import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import MultiSelectSearchWrapper from '../../../../../../../../../../components/MultiSelectDropdown/MultiSelectSearchWrapper';
import SearchGlobalSearchInput from '../../../../../../../../../../components/search/SearchGlobalSearchInput';
import {
  checkAllLinkedEntities,
  selectElementsToLinkToComment,
  updateLinkedEntities
} from '../../../../../../../../../../redux/modules/activityLog';

const ActivityLogMultiSelectSearchWrapper = ({
  title = '',
  searchBlueprint,
  minWidth,
  formatDataFunction,
  type
}) => {
  const dispatch = useDispatch();
  const linkedItems = useSelector(selectElementsToLinkToComment);

  const handleCheckAllSearch = data => {
    const entityLinkedItems = linkedItems.filter(item => item.type === type);
    const checkedItems = entityLinkedItems.length ? [] : data;

    dispatch(checkAllLinkedEntities(checkedItems, type));
  };

  return (
    <MultiSelectSearchWrapper
      displayLength={1}
      formatDataFunction={formatDataFunction}
      handleCheckAll={handleCheckAllSearch}
      idKey="id"
      labelKey="description"
      minWidth={minWidth}
      searchBlueprint={searchBlueprint}
      searchComponent={() => <SearchGlobalSearchInput searchBlueprint={searchBlueprint} width={minWidth} />}
      selectedValues={(linkedItems || []).filter(item => item.type === type)}
      title={title}
      onChange={selected => dispatch(updateLinkedEntities(selected, type))}
    />
  );
};

/** Wraps MultiSelectSearchWrapper with ActivityLog-specific data and functionality */
ActivityLogMultiSelectSearchWrapper.propTypes = {
  /** Placeholder/title that will appear on or above button */
  title: PropTypes.string,
  /** Elasticsearch blueprint to use */
  searchBlueprint: PropTypes.shape({
    getPage: PropTypes.func,
    selectData: PropTypes.func,
    selectPageInfo: PropTypes.func
  }),
  /** Width of button and menu */
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Function passed if data needs to be mapped into a different shape */
  formatDataFunction: PropTypes.func,
  /** Entity type for the data */
  type: PropTypes.string
};

export default ActivityLogMultiSelectSearchWrapper;
